import React from 'react'
import { Link } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'
import { FooterBottomStrip } from '../../footer.props'
import { IconSentecaCommerce } from '../../../Common/Icons'

export const BottomStrip = ({ items }: BottomStripProps) => {
  return (
    <Container>
      <List>
        <li className="col-12 col-lg-8 mr-lg-auto">
          <div className="row justify-content-center justify-content-lg-start">
            {items?.map((item, index) => (
              <React.Fragment key={`${item.text}__${item.url}`}>
                {item.url && (
                  <ListItem as="div">
                    <Link passHref href={item.url}>
                      <a>{item.text}</a>
                    </Link>
                  </ListItem>
                )}

                {!item.url && (
                  <ListItem as="span">
                    {item.text}
                    {index < items.length - 1 && <Spacer>|</Spacer>}
                  </ListItem>
                )}
              </React.Fragment>
            ))}
          </div>
        </li>
        <Disclaimer>
          <a
            href="https://sentecacommerce.com/"
            target="_blank"
            rel="noreferrer"
            className="d-flex mx-auto mx-lg-0 ml-lg-auto align-items-center"
          >
            <span style={{ fontSize: '1.4rem' }}>Онлайн магазин от</span>
            <StyledSentecaLogo />
          </a>
        </Disclaimer>
      </List>
    </Container>
  )
}

type BottomStripProps = {
  items: FooterBottomStrip
}

const Container = styled.div.attrs({
  className: 'container',
})``

const StyledSentecaLogo = styled(IconSentecaCommerce)`
  color: ${({ theme }) => theme.palette.primary};
`

const Disclaimer = styled.li.attrs({
  className: 'col-12 col-lg-4 order-first order-lg-last mt-2',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  font-size: 1.35rem;
  color: ${({ theme }) => theme.palette.greyTitle};

  div {
    margin-left: auto;

    display: flex;
    align-items: center;
  }

  span {
    margin-right: 0.7rem;
  }

  & svg {
    width: 14rem;
    height: auto;
  }
`

const List = styled.ul.attrs({
  className:
    'row gx-3 pb-3 justify-content-center justify-content-lg-start align-items-lg-center',
})`
  color: ${({ theme }) => theme.palette.lightgrey};
  line-height: 2.4rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md.max}) {
    flex-wrap: nowrap;
    margin: 0;
  }
`

const ListItem = styled.li.attrs({
  className: 'col-auto px-0 mt-2',
})`
  color: ${({ theme }) => theme.palette.greyTitle};

  & a {
    font-size: inherit;
    line-height: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
`

const Spacer = styled.span.attrs({
  className: 'd-inline-block pl-4',
})`
  &:before {
    content: ' ';
  }
  &:after {
    content: ' ';
  }
`
